import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <a href="/">
            <div aria-label="DFW Health Tech Home" className="navigation-brand">
              <div className="navigation-logo-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
                  ></path>
                </svg>
              </div>
              <span className="navigation-brand-name section-title">
                DFW Health Tech
              </span>
            </div>
          </a>
          <div className="navigation-desktop-menu">
            <ul className="navigation-links">
              <li>
                <a href="/">
                  <div className="navigation-link">
                    <span>Directory</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/investors">
                  <div className="navigation-link">
                    <span>Investors</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/accelerators">
                  <div className="navigation-link">
                    <span>Accelerators</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/news-insights">
                  <div className="navigation-link">
                    <span>News &amp; Insights</span>
                  </div>
                </a>
              </li>
            </ul>
            <div className="navigation-actions">
              <a href="/submit">
                <div className="btn btn-outline btn-sm">
                  <span>Submit Company</span>
                </div>
              </a>
              <a href="/newsletter">
                <div className="btn btn-sm btn-primary">
                  <span>Subscribe</span>
                </div>
              </a>
            </div>
          </div>
          <button
            id="navToggle"
            aria-label="Open Menu"
            aria-expanded="false"
            aria-controls="mobileOverlay"
            className="navigation-mobile-toggle"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>
      </nav>
      <div
        id="mobileOverlay"
        aria-hidden="true"
        className="navigation-mobile-overlay"
      >
        <div className="navigation-overlay-header">
          <a href="/">
            <div aria-label="DFW Health Tech Home" className="navigation-brand">
              <div className="navigation-logo-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
                  ></path>
                </svg>
              </div>
              <span className="navigation-brand-name section-title">
                DFW Health Tech
              </span>
            </div>
          </a>
          <button
            id="navClose"
            aria-label="Close Menu"
            className="navigation-mobile-close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M18 6L6 18M6 6l12 12"
              ></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <ul className="navigation-mobile-links">
            <li>
              <a href="/">
                <div className="navigation-mobile-link">
                  <span>Company Directory</span>
                </div>
              </a>
            </li>
            <li>
              <a href="/investors">
                <div className="navigation-mobile-link">
                  <span>Investors</span>
                </div>
              </a>
            </li>
            <li>
              <a href="/accelerators">
                <div className="navigation-mobile-link">
                  <span>Accelerators</span>
                </div>
              </a>
            </li>
            <li>
              <a href="/news-insights">
                <div className="navigation-mobile-link">
                  <span>News &amp; Insights</span>
                </div>
              </a>
            </li>
          </ul>
          <div className="navigation-mobile-actions">
            <a href="/submit">
              <div className="btn btn-outline btn-lg">
                <span>Submit a Company</span>
              </div>
            </a>
            <a href="/newsletter">
              <div className="btn btn-primary btn-lg">
                <span>Join the Newsletter</span>
              </div>
            </a>
          </div>
          <div className="navigation-mobile-footer">
            <p className="section-content">
              Professional intelligence for the DFW health tech ecosystem.
            </p>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const navToggle = document.getElementById('navToggle');
  const navClose = document.getElementById('navClose');
  const mobileOverlay = document.getElementById('mobileOverlay');

  const openMenu = () => {
    mobileOverlay.classList.add('is-active');
    mobileOverlay.setAttribute('aria-hidden', 'false');
    navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    mobileOverlay.classList.remove('is-active');
    mobileOverlay.setAttribute('aria-hidden', 'true');
    navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  navToggle.addEventListener('click', openMenu);
  navClose.addEventListener('click', closeMenu);

  mobileOverlay.addEventListener('click', (e) => {
    if (e.target.classList.contains('navigation-mobile-link')) {
      closeMenu();
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 767 && mobileOverlay.classList.contains('is-active')) {
      closeMenu();
    }
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
